import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '@/components/layout/PublicLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Calculator, DollarSign, FileText, TrendingUp, Building, Users, Phone } from 'lucide-react';

export default function ToolsPage() {
  const navigate = useNavigate();

  const tools = [
    {
      icon: DollarSign,
      title: 'Tax Refund Estimator',
      description: 'Estimate your federal tax refund or liability'
    },
    {
      icon: Calculator,
      title: 'Tax Bracket Calculator',
      description: 'Calculate your effective tax rate and bracket'
    },
    {
      icon: FileText,
      title: 'Deduction Finder',
      description: 'Find all the deductions you qualify for'
    },
    {
      icon: TrendingUp,
      title: 'Self-Employment Tax Calculator',
      description: 'Estimate taxes if you work for yourself'
    },
    {
      icon: Building,
      title: 'LLC Cost Calculator',
      description: 'Calculate the cost to form your LLC'
    },
    {
      icon: Users,
      title: 'Business Tax Estimator',
      description: 'Estimate quarterly tax obligations'
    }
  ];

  return (
    <PublicLayout>
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-4">Calculators & Tools</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Free tools to help you estimate your taxes and plan ahead
          </p>
        </div>

        {/* Tools Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tools.map((tool, index) => {
            const Icon = tool.icon;
            return (
              <Card key={index} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="h-6 w-6 text-blue-600" />
                  </div>
                  <CardTitle className="text-xl">{tool.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 dark:text-gray-400 mb-4">{tool.description}</p>
                  <Button className="w-full" onClick={() => navigate('/contact')}>
                    <Phone className="mr-2 h-4 w-4" /> Contact Us
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Note */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 dark:text-gray-400">
            These calculators are for estimation purposes only. For accurate tax planning, please consult with our tax professionals.
          </p>
        </div>
      </div>
    </PublicLayout>
  );
}